<template>
    <el-dialog
        ref="DialogMachine"
        v-model="visibled"
        :title="title"
        width="400"
        align-center
        draggable
        @closed="onClosed"
        @keyup.enter="onClosed">
        <el-tooltip :content="tooltip" placement="top">
            <div style="cursor: pointer" @click="onclick">
                <qrcode-vue :value="qrValue" :size="size" level="H" />
            </div>
        </el-tooltip>
        <div style="text-wrap-mode: nowrap; overflow: overlay; scrollbar-width: none;">
            <el-tooltip :content="'点击拷贝链接'" placement="top">
                <el-icon class="copylink" :data-clipboard-text="qrValue"><DocumentCopy /></el-icon>
            </el-tooltip>
            {{ qrValue }}
        </div>
    </el-dialog>
</template>

<script>
// import {asleep} from '../../assets/js/utils.js';
// import dayjs from 'dayjs';
import QrcodeVue from 'qrcode.vue';
import {notify} from '../../assets/js/utils.js';
import {DocumentCopy} from '@element-plus/icons-vue';
import ClipboardJS from 'clipboard';

function isAsyncFunction(func) {
    return Object.prototype.toString.call(func) === '[object AsyncFunction]';
}

export default {
    name: 'TaskQRCode',
    components: {
        QrcodeVue,
        DocumentCopy,
    },
    props: {
    },
    data() {
        return {
            visibled: false,
            resolve: null,
            reject: null,
            title: null,
            list: [],
            data: {},
            machines: [],
            size: 200,
            tooltip: null,
        };
    },
    computed: {
        validate() {
            return true;
        },
        is_new() {
            console.log(`is new ${!this.options.data.id}`);
            return !this.data.id;
        },
        qrValue() {
            return this.options.url;
        },
    },
    mounted() {
        const clipboard = new ClipboardJS('.copylink');
        clipboard.on('success', function() {
            notify('success', '拷贝成功', 2222);
        });

        clipboard.on('error', function(e) {
            notify('warning', '拷贝失败', 9999);
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });
    },
    methods: {
        async show(options) {
            console.debug(options);
            this.options = options;
            this.tooltip = options.tooltip;
            this.title = options.title;
            this.visibled = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        async onclick() {
            if (this.options.click) {
                if (isAsyncFunction(this.options.click)) {
                    await this.options.click(this.options);
                } else {
                    this.options.click(this.options);
                }
            }
        },
        activate() {
            (async () => {
                try {
                    const device_code = this.options.device_code;
                    const order_code = this.options.order_code;
                    const url = this.qrValue;
                    await this.axios.get(url);
                    notify('success', `设备${device_code}已设置任务单号${order_code}.`, 2222);
                } catch (exc) {
                    console.error(exc);
                }
            })();
        },
        onClosed() {
            if (this.reject) {
                this.reject();
            }
        },
    },
};
</script>

<style>

</style>
